import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { maskCPF } from '../utils/masks';
import { getCurriculo } from '../api';
import axios from 'axios';

export default function CPFScreen() {
  const [cpf, setCpf] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [backendStatus, setBackendStatus] = useState<'ok' | 'fail' | 'checking'>('checking');
  const navigate = useNavigate();
  const token = sessionStorage.getItem('authToken');

  useEffect(() => {
    if (!token) {
      navigate('/acesso-profissional');
      return;
    }
    setBackendStatus('checking');
    axios
      .get((process.env.REACT_APP_API_URL || 'http://localhost:5000/api') + '/health')
      .then(() => setBackendStatus('ok'))
      .catch(() => setBackendStatus('fail'));
  }, [token, navigate]);

  const handleConfirm = async () => {
    setError('');

    const clean = cpf.replace(/\D/g, '');
    if (clean.length !== 11) {
      setError('CPF deve ter 11 dígitos');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await getCurriculo(clean);
      // res: { exists: boolean, data: ... }
      if (res && res.data) {
        sessionStorage.setItem('cpf', clean);
        sessionStorage.setItem('curriculoData', JSON.stringify(res.data));
      } else {
        sessionStorage.setItem('cpf', clean);
        sessionStorage.removeItem('curriculoData'); // evita salvar "null"
      }
      navigate('/curriculo');
    } catch (e: any) {
      console.error(e);
      if (e?.response?.status === 401) {
        sessionStorage.removeItem('authToken');
        navigate('/acesso-profissional');
      } else {
        setError('Erro ao conectar com backend');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', paddingTop: '32px' }}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <img src="/assets/icones-curriculo-05.svg" alt="Ícone Profissional" style={{ width: '48px', height: '48px', marginBottom: '8px' }} />
        <h2 style={{ color: 'var(--primary-color)' }}>Acesso ao Banco</h2>
        <p style={{ color: 'var(--text-light)', fontSize: '15px' }}>Informe os dados abaixo para continuar.</p>
      </div>
      {backendStatus === 'checking' && (
        <div style={{ color: 'var(--text-light)', marginBottom: 10, textAlign: 'center' }}>Verificando conexão com o servidor...</div>
      )}
      {backendStatus === 'fail' && (
        <div style={{ color: 'red', marginBottom: 10 }}>
          Não foi possível conectar ao backend. Verifique a configuração do backend e tente novamente.
        </div>
      )}
      <div className="form-group" style={{ maxWidth: 380 }}>
        <label>CPF</label>
        <input placeholder="000.000.000-00" value={cpf} onChange={(e) => setCpf(maskCPF(e.target.value))} />
      </div>
      {error && <div className="error-message">{error}</div>}
      <div style={{ marginTop: 12, display: 'flex', gap: 10 }}>
        <button className="btn btn-primary" onClick={handleConfirm} disabled={loading}>
          <img src="/assets/icones-curriculo-01.svg" alt="Ícone Acessar" style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} />
          {loading ? 'Carregando...' : 'Confirmar CPF'}
        </button>
        <button className="btn btn-outline" onClick={() => navigate('/acesso-profissional')}>
          Voltar
        </button>
      </div>
    </div>
  );
}
